import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';

import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class CaseLockUnlockCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               private dialogService: DialogService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService, ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const isLocked = command.fieldValues['IsLocked'];

    const status = isLocked ? 'Lock' : 'Unlock'
    const message = this.getMessage(isLocked);
    const question = `Are you sure you want to ${status} this case?`;
    const title = status + ' Case';

    this.dialogService.showConfirmDialog(title, title, 'Cancel', message, question).subscribe(res => {
      if (res.action === 'OK') {
        this.executeCommandToApi(command, handler);
      }
    });

    return true;
  }

  private getMessage(isLocked: boolean) {
    if (isLocked)
      return "If you lock this case it will be read-only.";
    return "If you unlock this case you can edit it.";
  }
}
